import {
    Input,
    Directive,
    ElementRef,
    HostListener,
    HostBinding,
    OnChanges
} from '@angular/core';
declare const nw: any;

const LEFT_CLICK = 1;
const TARGET_BLANK = '_blank';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: 'a[href]'
})
export class ADirective implements OnChanges {
    @Input() href: string;

    @HostBinding('attr.href') hrefAttr = '';
    @HostBinding('attr.rel') relAttr = '';
    @HostBinding('attr.target') targetAttr = '';

    constructor(
        private _el: ElementRef<HTMLAnchorElement>
    ) {
    }

    ngOnChanges() {
        this.hrefAttr = this.href;

        setTimeout(() => {
            if (this.isLinkExternal()) {
                this.relAttr = 'noopener';
                this.targetAttr = '_blank';
            }
        });
    }

    @HostListener('click', ['$event'])
    onClick($event) {
        const { ctrlKey, which } = $event;

        try {
            if (nw) {
                // Noop.
            }
        } catch (err) {
            return true;
        }

        if (ctrlKey && which === LEFT_CLICK) {
            $event.preventDefault();
        }

        if (this._el.nativeElement.target === TARGET_BLANK) {
            nw.Shell.openExternal(this.href);
            $event.preventDefault();
        }
    }

    private isLinkExternal() {
        return !this._el.nativeElement.href.includes(location.hostname);
    }
}
